export var ScheduledReportsSuccessNotifications;
(function (ScheduledReportsSuccessNotifications) {
    ScheduledReportsSuccessNotifications["Create"] = "Report created";
    ScheduledReportsSuccessNotifications["Update"] = "Report updated";
    ScheduledReportsSuccessNotifications["Delete"] = "Report deleted";
    ScheduledReportsSuccessNotifications["Test"] = "Test Report Sent";
    ScheduledReportsSuccessNotifications["Activate"] = "Enabled report";
    ScheduledReportsSuccessNotifications["Deactivate"] = "Disabled report";
})(ScheduledReportsSuccessNotifications || (ScheduledReportsSuccessNotifications = {}));
export var ScheduledReportsNotificationSubjects;
(function (ScheduledReportsNotificationSubjects) {
    ScheduledReportsNotificationSubjects["Create"] = "create-report";
    ScheduledReportsNotificationSubjects["Update"] = "update-report";
    ScheduledReportsNotificationSubjects["Delete"] = "delete-report";
    ScheduledReportsNotificationSubjects["Test"] = "test-report";
    ScheduledReportsNotificationSubjects["Deactivate"] = "deactivate-report";
    ScheduledReportsNotificationSubjects["Activate"] = "activate-report";
})(ScheduledReportsNotificationSubjects || (ScheduledReportsNotificationSubjects = {}));
export var ScheduledReportsEmptyState;
(function (ScheduledReportsEmptyState) {
    ScheduledReportsEmptyState["Title"] = "Nothing to report, Captain.";
    ScheduledReportsEmptyState["Subtitle"] = "You haven't set up any reports yet. Schedule a new report to get a regular view of the system's health.";
})(ScheduledReportsEmptyState || (ScheduledReportsEmptyState = {}));
export var ScheduledReportsErrors;
(function (ScheduledReportsErrors) {
    ScheduledReportsErrors["DeactivatedByServer"] = "We had to disable this report. Please fix any issues and reactivate.";
})(ScheduledReportsErrors || (ScheduledReportsErrors = {}));
export var ScheduledReportTestSubjects;
(function (ScheduledReportTestSubjects) {
    ScheduledReportTestSubjects["EditPage"] = "scheduled-reports-edit-page";
})(ScheduledReportTestSubjects || (ScheduledReportTestSubjects = {}));
//# sourceMappingURL=scheduled-reports.enum.js.map